import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import { useDispatch, useSelector } from 'react-redux'
import { useInputChange } from 'hooks/useInputChange';
import { ViewDataZreports } from './ViewComponent';
import {
    IdZreportsState,
    typeZreportsFilters
} from 'model/dashboardZreports/dZreportReducer';
import {
    dZReportsClearFiltersAC, dZReportsExportDataSagaAC, dZReportsExportSalesSagaAC,
    dZReportsSetDataSagaAC,
    dZReportsSetDetailItemAC,
    dZReportsSetFiltersAC, dZReportsSetItemsForPageAC, dZReportsSetPageNumberAC
} from 'model/dashboardZreports/dZreportsActionCreators';
import { typePaginationDashboardObject } from '../DashboardContentTable/PaginationDashboard/PaginationDashboard';
import { ISystemState } from 'model/system/systemReducer';


// Type
export type typeZreports = {
    variant?: string
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export type typeDataZReportsRowActions = { title: JSX.Element, action: (id: string) => void }[]
export type typeDataZReportsBulkActions = { title: JSX.Element, action: (allItems: boolean) => void }[]


// Component
export const DataZreports: React.FC<typeZreports> = ({ variant, setSidebarOpen }) => {

    const dispatch = useDispatch()

    // System data
    const currentLang = useSelector((state: { system: ISystemState }) => state.system.language)
    // DateFilter
    const [isActiveFilters, setIsActiveFilters] = useState(false)
    const [ openFilterBar, setOpenFilterBar ] = useState(false)
    const filters = useSelector((state: { dZReports: IdZreportsState }) => state.dZReports.filters)

    // Pagination
    const pagination: typePaginationDashboardObject = {
        paginationObject: useSelector((state: { dZReports: IdZreportsState }) => state.dZReports.pagination),
        onGoToPage: (id) => dispatch(dZReportsSetPageNumberAC(id)),
        onSelectItems: (itemsPerPage) => dispatch(dZReportsSetItemsForPageAC(itemsPerPage))

    }


    // Did mount & Did unmount
    useEffect(() => {
        return () => {
            dispatch(dZReportsClearFiltersAC())
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {

        dispatch(dZReportsSetDataSagaAC(
            filters,
            {
                page: pagination.paginationObject.pageNumber,
                size: pagination.paginationObject.itemsPerPage!
            }))

        if(!searchStoreName){setSearchValue('')}
        // eslint-disable-next-line
    }, [ filters, pagination.paginationObject.pageNumber, pagination.paginationObject.itemsPerPage ])

    // Search panel

    const searchStoreName = useSelector((state: { dZReports: IdZreportsState }) => state.dZReports.filters.userName)

    const {
        value: searchValue,
        setValue: setSearchValue,
        changeValueHandler: onChangeSearchValue
    } = useInputChange(searchStoreName ? searchStoreName : '')

    const onClearSearch = () => {
        dispatch(dZReportsSetFiltersAC({
                                           userName:  null
                                       }))

        setSearchValue('')
    }
    const onEnterSearch = () => {

        const filters: typeZreportsFilters = {
            userName: searchValue.trim()
        }
        dispatch(dZReportsSetFiltersAC(filters))

    }


    // Popup Print
    const [ openPopupPrint, setOpenPopupPrint ] = useState(false)

    // Popup details
    const [ openPopupDetails, setOpenPopupDetails ] = useState(false)


    // Current item
    const currentItem = useSelector((state: { dZReports: IdZreportsState }) => state.dZReports.detailItem)


    // Make table item actions
    const rowsActions: typeDataZReportsRowActions = [
        {
            title: <Trans>Sale's export from this Z-report</Trans>,
            action: (id: string) => {
                dispatch(dZReportsExportSalesSagaAC([id],currentLang))

            }
        },

        {
            title: <Trans>Print</Trans>,
            action: (id: string) => {
                dispatch(dZReportsSetDetailItemAC(id))
                setOpenPopupPrint(true)

            }
        },
    ]
    // Export All
    const onAllClickExport = () => {
        dispatch(dZReportsExportDataSagaAC([]))
    }

    // Export selected
    const onSelectedClickExportZReports = () => {
        const zReportsIds: string[] = Object.values(ZReportsList.filter(item => item.checked).map(item => item.id))
        dispatch(dZReportsExportDataSagaAC(zReportsIds))

    }

    const onSelectedClickExportSalesReports = () => {
        const zReportsIds: string[] = Object.values(ZReportsList.filter(item => item.checked).map(item => item.id))
        dispatch(dZReportsExportSalesSagaAC(zReportsIds, currentLang))

    }

    // Make bulk actions
    const ZReportsList = useSelector((state: { dZReports: IdZreportsState }) =>
                                         state.dZReports.data);


    const bulkActions: typeDataZReportsBulkActions = [
        {
            title: <Trans>Export selected z-reports</Trans>,
            action: () => onSelectedClickExportZReports()
        },
        {
            title: <Trans>Export Sale's report from selected z-reports</Trans>,
            action: () => onSelectedClickExportSalesReports()
        }

    ]

    // Print dialog actions
    const cancelPrint = () => {
        setOpenPopupPrint(false)
    }
    const printHandler = () => {
        setOpenPopupPrint(false)
    }

    return (
        <ViewDataZreports

            variant={ variant }
            setSidebarOpen={ setSidebarOpen }

            openFilterBar={ openFilterBar }
            setOpenFilterBar={ setOpenFilterBar }

            openPopupDetails={ openPopupDetails }
            setOpenPopupDetails={ setOpenPopupDetails }

            openPopupPrint={ openPopupPrint }
            setOpenPopupPrint={ setOpenPopupPrint }
            onCancelPrint={ cancelPrint }
            onPrintSubmitClick={ printHandler }

            searchValue={ searchValue }
            onChangeSearchValue={ onChangeSearchValue }
            onEnterSearch={ onEnterSearch }
            onClearSearch={ onClearSearch }

            rowsActions={ rowsActions }
            bulkActions={ bulkActions }

            onAllClickExport={ onAllClickExport }
            currentItem={ currentItem }
            pagination={ pagination }
            isActiveFilters={isActiveFilters}
            setIsActiveFilters={setIsActiveFilters}
        />

    )
}
